import React from "react";
import ReactDOM from "react-dom";
// class-transformer's requirement
import "reflect-metadata";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Provider } from "react-redux";
import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducer from "./redux/reducers";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { PersistGate } from "redux-persist/integration/react";
import * as Sentry from "@sentry/react";
import "react-calendar-timeline/lib/Timeline.css";
import "rc-tooltip/assets/bootstrap.css";
const persistConfig = {
  key: "react-template",
  storage,
  whitelist: ["account"],
};

if (process.env.REACT_APP_SENTRY_ENABLED) {
  Sentry.init({
    dsn: "https://ec18c735fa6c4e8f8e82e474086ee61a@o429554.ingest.sentry.io/5376407",
    environment: process.env.NODE_ENV,
  });
}
const persistedReducer = persistReducer(persistConfig, reducer);
const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(thunk));

export const store = createStore(persistedReducer, enhancer);
const persistor = persistStore(store);

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
